import { render } from "./VipRefund.vue?vue&type=template&id=4b5906f4&scoped=true"
import script from "./VipRefund.vue?vue&type=script&lang=js"
export * from "./VipRefund.vue?vue&type=script&lang=js"

import "./VipRefund.vue?vue&type=style&index=0&id=4b5906f4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5906f4"]])

export default __exports__